export const depositModelConditions = {
  methods: {
    depositModelConditions(conditions) {
      const that = this;
      let depositModelConditions = conditions;
      if (depositModelConditions != null) {
        depositModelConditions = Object.values(depositModelConditions).map(
          condition => {
            // check if condition has alterantive values = object
            if (typeof condition === "object") {
              // … then return value based on selected option from step 4 (assets)
              let assetsState = that.$store.getters.getAssetsState;
              if (assetsState >= 6) {
                // If user selected assets >= 200k
                return condition.a;
              } else if (assetsState >= 4 && assetsState < 6) {
                // If user selected >= 100k && < 200k
                return condition.b;
              } else if (assetsState <= 3) {
                // If user selected < 100k
                return condition.c;
              }
            } else {
              return condition;
            }
          }
        );
      }
      return depositModelConditions;
    }
  }
};
